import Vue from 'vue'

export const namespaced = true

export const state = {
  messages: [],
  message: {},
  total: 0,
  page: 1,
  limit: 10,
  messagesLoading: false,
  messageLoading: false
}

//MUTATIONS are synchronous : mutate / update state => this.$store.commit('ADD_EVENT')
export const mutations = {

  SET_MESSAGES_LIST (state, messages) {
    // console.log(messages)
    state.messages = messages
  },

  SET_MESSAGE (state, message) {
    state.message = message
  },

  SET_MESSAGES_TOTAL (state, total) {
    state.total = total
  },

  SET_MESSAGES_LOADING (state, loading) {
    state.messagesLoading = loading
  },

  SET_MESSAGE_LOADING (state, loading) {
    state.messageLoading = loading
  }
}

//ACTIONS are assynchronous : actions fetch datas (AJAX) then send results to mutations (to update local state)  => this.$store.dispatch('createEvent')
export const actions = {

  getAllMessages ({ commit, dispatch }, { page, limit }) {
    commit('SET_MESSAGES_LOADING', true)
    //check values or take default
    page = page ? page : state.page
    limit = limit ? limit : state.limit

    return Vue.axios.get(`/messages?page=${page}&limit=${limit}`)
      .then(response => {
        commit('SET_MESSAGES_LIST', response.data)
        commit('SET_MESSAGES_TOTAL', response.headers['x-total-count'])
        commit('SET_MESSAGES_LOADING', false)
      })
      .catch(error => {
        commit('SET_MESSAGES_LOADING', false)
        dispatch('displayError', {message: 'Erreur de chargement des messages', error}, {root: true})
      })
  },

  getMessage ({commit, dispatch}, id) {
    commit('SET_MESSAGE_LOADING', true)
    return Vue.axios.get(`/messages/${ id }`)
      .then(response => {
        commit('SET_MESSAGE', response.data)
        commit('SET_MESSAGE_LOADING', false)
      })
      .catch(error => {
        commit('SET_MESSAGE_LOADING', false)
        dispatch('displayError', {message: 'Erreur de chargement du message', error}, {root: true})
      })
  },

  saveMessage ({ commit, dispatch }, message) {
    commit('SET_MESSAGE_LOADING', true)
    if (!message.id || message.id === -1) {
      return Vue.axios.post('/messages', message)
        .then(() => {
          commit('SET_MESSAGE_LOADING', false)
          dispatch('displaySuccess', 'Message créé', {root: true})
        })
        .catch(error => {
          commit('SET_MESSAGE_LOADING', false)
          dispatch('displayError', {message: 'Erreur lors de la création du message', error}, {root: true})
          throw error
        })
    } else {
      return Vue.axios.put(`/messages/${message.id}`, message)
        .then(() => {
          commit('SET_MESSAGE_LOADING', false)
          dispatch('displaySuccess', 'État du message modifié', {root: true})
        })
        .catch(error => {
          commit('SET_MESSAGE_LOADING', false)
          dispatch('displayError', {message: 'Erreur de modification du message', error}, {root: true})
          throw error
        })
    }
  },

  deleteMessage ({ commit, dispatch }, id) {
    commit('SET_MESSAGE_LOADING', true)
    return Vue.axios.delete(`/messages/${id}`)
      .then(() => {
        commit('SET_MESSAGE', {})
        commit('SET_MESSAGE_LOADING', false)
        dispatch('displaySuccess', 'Message supprimé', {root: true})
      })
      .catch(error => {
        commit('SET_MESSAGE_LOADING', false)
        dispatch('displayError', {message: 'Erreur de suppression de message', error}, {root: true})
      })
  }
}

//GETTERS Returns current state objects with logic/filter functions
export const getters = {
  messagesOrderByDate: state => {
    return state.messages.slice().sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
  },
  unreadMessages: state => {
    return state.messages.filter(m => m.lu !== true).length
  }
}
